var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data !== undefined)?_c('div',[_c('operaters-bar',{attrs:{"data":_vm.data}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }